import React from 'react';
import api from 'rawr/api';
import log from 'rawr/utils/log';
import Button from 'rawr/layout/Button';
import notify from 'rawr/notify';
import Columns from 'rawr/layout/Columns';

import './Contact.scss';

export default React.createClass({
    propTypes: {
        extraData: React.PropTypes.func,
    },
    getInitialState() {
        return {
            email: this.props.user.email,
            message: '',
            issueType: '',
            issueDescriptionType: '',
            subject: '',
            isSendButtonDisabled: false
        }
    },
    isSendButtonDisabled() {
        return (this.state.issueType === '' || (this.state.issueType === 'issueDescription' &&
            this.state.issueDescriptionType === '')) ||
            this.state.message === '' || (this.props.user.email && this.state.email === '');
    },
    setStateByKey(key, event) {
        this.setState({..._.omit(this.state, key), [key]: event.target.value})
    },
    sendMessage() {
        this.setState({isSendButtonDisabled: true});
        const user = this.props.user || {};
        const {subject, issueDescriptionType, issueType} = this.state;

        const body = {
            message: this.state.message,
            email: user.email || this.state.email,
            first_name: user.first_name,
            last_name: user.last_name,
            user_id: user.id,
            browser: navigator.userAgent,
            url: location.href,
            logs: log.getCollected(),
            subject: (issueDescriptionType || issueType) + (subject ? ' - ' + subject : '')
        };


        if (this.props.extraData) {
            _.assign(body, this.props.extraData());
        }

        return api.post(config.contact_post_url, {
            body: body
        }).then(function () {
            notify("Send", {timeout: 5})
        }, function () {
            notify.error("Error while sending mail", {timeout: 5});
        });
    },
    render() {
        return (
            <div className="Contact">
                {this.state.successful ? (
                    <div>Thank you! Your inquiry has been sent to our Support team.</div>
                ) : (
                    <div>
                        <Columns className="Contact__column">
                            <span>Type of issue</span>
                            <select value={this.state.issueType} defaultValue=""
                                    onChange={this.setStateByKey.bind(this, 'issueType')}>
                                <option value="">Choose here</option>
                                <option value="loggingIn">Logging in</option>
                                <option value="passwords">Passwords</option>
                                <option value="assignment">Assignment</option>
                                <option value="printing">Printing</option>
                                <option value="results">Results</option>
                                <option value="issueDescription">Other</option>
                            </select>
                        </Columns>

                        { this.state.issueType === "issueDescription" ?
                            <Columns className="Contact__column">
                                <span>Issue description</span>
                                <input className="Contact__input" type="text" value={this.state.issueDescriptionType}
                                       onChange={this.setStateByKey.bind(this, 'issueDescriptionType')}/>
                            </Columns>
                            : null
                        }

                        <div className="Contact__column">
                            <div>Subject</div>
                            <div>
                            <input className="Contact__subject Contact__input" type="text" value={this.state.subject}
                                   onChange={this.setStateByKey.bind(this, 'subject')}/>
                            </div>
                        </div>

                        {this.props.user.email ? null : (
                            <div className="Contact__column">
                                <div>Email</div>
                                <div>
                                <input className="Contact__input" type="text" value={this.state.email}
                                       onChange={this.setStateByKey.bind(this, 'email')}
                                       name='email'/>
                                </div>
                            </div>
                        )}

                        <div className="Contact__column">
                            <span>Message</span>
                            <div>
                                <textarea className="Contact__message" value={this.state.message}
                                          onChange={this.setStateByKey.bind(this, 'message')}/>
                            </div>
                        </div>

                        {this.state.failed ? <div>{this.state.failed.toString()}</div> : null}

                        <Button btn={{color: 'blue'}} className="Contact__button" disabled={this.isSendButtonDisabled() || this.state.isSendButtonDisabled}
                                onClick={() => this.sendMessage()}>Send</Button>
                    </div>
                )}
            </div>
        );
    }
});



/** WEBPACK FOOTER **
 ** /mnt/jenkins/jobs/master/workspace/core/client/rawr/controls/Contact.jsx
 **/